import { render, staticRenderFns } from "./quiz_index.vue?vue&type=template&id=38240ecf&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app.whytemperament.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38240ecf')) {
      api.createRecord('38240ecf', component.options)
    } else {
      api.reload('38240ecf', component.options)
    }
    module.hot.accept("./quiz_index.vue?vue&type=template&id=38240ecf&", function () {
      api.rerender('38240ecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js_src/quiz/quiz_index.vue"
export default component.exports